<template>
  <div class="app-rules-container">
    <div class="app-rules-scrollbox">
      <IscrollView ref="iscroll">
      <div class="row">
        <span class="order-num">1</span>
        <span class="label">大赛全称：</span>
        <span class="detail">交易MVP——交易侠·黄金白银实盘赛</span>
      </div>
      <div class="row">
        <span class="order-num">2</span>
        <span class="label">主办方：</span>
        <span class="detail">金十数据——交易侠</span>
      </div>
      <div class="row">
        <span class="order-num">3</span>
        <span class="label">参赛者：</span>
        <span class="detail">报名后，在交易侠成功开通上海黄金交易所的贵金属账户并交易，即可参赛</span>
      </div>
      <div class="row">
        <span class="order-num">4</span>
        <span class="label">报名时间：</span>
        <span class="detail">{{ registrationTime }}</span>
      </div>
      <div class="row">
        <span class="order-num">5</span>
        <span class="label">比赛时间：</span>
        <span class="detail">{{ gameTime }}</span>
      </div>
      <div class="row">
        <span class="order-num">6</span>
        <span class="label">报名规则：</span>
        <div class="detail">
          <p class="detail__line" style="margin-top: 0;">
            <span class="detail__line__icon"></span>报名时间截止前，可在大赛官网提交信息报名； 
          </p>
          <p class="detail__line">
            <span class="detail__line__icon"></span>账户资金要求：<br />
            <span style="color: #F1C9C0">轻量组（0元&lt;账户资金&lt;100000元人民币）</span><br />
            <span style="color: #F1C9C0">重量组（账户资金≥100000元人民币）</span><br />
            <span>注：比赛期间参赛者可出入金，账户累计投入资金超过100000元人民币，则自动升级到重量组，之前成绩保留并继续在重量组进行比赛。</span>
          </p>
          <p class="detail__line">
            <span class="detail__line__icon"></span>
            提交报名信息后，在交易侠成功开通上海黄金交易所的贵金属账户并交易，在交易日结算后，公示参赛成绩。比赛排行按比赛期间的交易情况计算，其它时段交易情况不计入大赛得分；
          </p>
          <p class="detail__line">
            <span class="detail__line__icon"></span>
            一个用户最多可使用1个实盘交易账户，如选手在大赛期间，被监测发现不当的账户操作行为，主办方有权取消参赛资格，并清除相关账号成绩。
          </p>
        </div>
      </div>
      <div class="row" style="padding-bottom: 24px">
        <span class="order-num">7</span>
        <span class="label">犯规退赛：</span>
        <span class="detail">活动期间，参赛选手发生异常交易情况，违反公平竞赛原则，主办方有权取消其参赛资格。</span>
      </div>
      </IscrollView>
    </div>
  </div>
</template>

<script>
import config from '../../config'

export default {
  name: "Intro",
  data () {
    return {
      registrationTime: config.registrationTime,
      gameTime: config.gameTime
    }
  },
  mounted () {
    setTimeout(() => {
      this.$refs.iscroll.refresh()
    }, 500)
  }
}
</script>
